var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.94445 85C7.34723 85 5.12306 84.0744 3.27195 82.2233C1.42084 80.3722 0.49686 78.1496 0.500008 75.5555V9.44445C0.500008 6.84723 1.42556 4.62306 3.27667 2.77195C5.12779 0.920841 7.35038 -0.00314013 9.94445 8.01736e-06H76.0555C78.6528 8.01736e-06 80.8769 0.925564 82.7281 2.77667C84.5792 4.62779 85.5031 6.85038 85.5 9.44445V75.5555C85.5 78.1528 84.5744 80.3769 82.7233 82.2281C80.8722 84.0792 78.6496 85.0031 76.0555 85H9.94445ZM14.6667 66.1111H71.3333L53.625 42.5L39.4583 61.3889L28.8333 47.2222L14.6667 66.1111Z",
    fill: "#B9B8BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c8741b13400369ca440001b27c9d542d.svg";
export { ForwardRef as ReactComponent };